export const WIDTH = {
    MAX_1850: '(max-width:1850px)',
    MAX_1800: '(max-width:1800px)',
    MAX_1700: '(max-width:1700px)',
    MAX_1600: '(max-width:1600px)',
    MAX_1400: '(max-width:1400px)',
    MAX_1300: '(max-width:1300px)',
    MAX_1280: '(max-width:1280px)',
}
